export interface TurkeyCity {
  id: number;
  name: string;
  plate: string;
}

export const TURKEY_CITIES: TurkeyCity[] = [
  { id: 1, name: "Adana", plate: "01" },
  { id: 2, name: "Adıyaman", plate: "02" },
  { id: 3, name: "Afyonkarahisar", plate: "03" },
  { id: 4, name: "Ağrı", plate: "04" },
  { id: 5, name: "Amasya", plate: "05" },
  { id: 6, name: "Ankara", plate: "06" },
  { id: 7, name: "Antalya", plate: "07" },
  { id: 8, name: "Artvin", plate: "08" },
  { id: 9, name: "Aydın", plate: "09" },
  { id: 10, name: "Balıkesir", plate: "10" },
  { id: 11, name: "Bilecik", plate: "11" },
  { id: 12, name: "Bingöl", plate: "12" },
  { id: 13, name: "Bitlis", plate: "13" },
  { id: 14, name: "Bolu", plate: "14" },
  { id: 15, name: "Burdur", plate: "15" },
  { id: 16, name: "Bursa", plate: "16" },
  { id: 17, name: "Çanakkale", plate: "17" },
  { id: 18, name: "Çankırı", plate: "18" },
  { id: 19, name: "Çorum", plate: "19" },
  { id: 20, name: "Denizli", plate: "20" },
  { id: 21, name: "Diyarbakır", plate: "21" },
  { id: 22, name: "Edirne", plate: "22" },
  { id: 23, name: "Elazığ", plate: "23" },
  { id: 24, name: "Erzincan", plate: "24" },
  { id: 25, name: "Erzurum", plate: "25" },
  { id: 26, name: "Eskişehir", plate: "26" },
  { id: 27, name: "Gaziantep", plate: "27" },
  { id: 28, name: "Giresun", plate: "28" },
  { id: 29, name: "Gümüşhane", plate: "29" },
  { id: 30, name: "Hakkari", plate: "30" },
  { id: 31, name: "Hatay", plate: "31" },
  { id: 32, name: "Isparta", plate: "32" },
  { id: 33, name: "Mersin", plate: "33" },
  { id: 34, name: "İstanbul", plate: "34" },
  { id: 35, name: "İzmir", plate: "35" },
  { id: 36, name: "Kars", plate: "36" },
  { id: 37, name: "Kastamonu", plate: "37" },
  { id: 38, name: "Kayseri", plate: "38" },
  { id: 39, name: "Kırklareli", plate: "39" },
  { id: 40, name: "Kırşehir", plate: "40" },
  { id: 41, name: "Kocaeli", plate: "41" },
  { id: 42, name: "Konya", plate: "42" },
  { id: 43, name: "Kütahya", plate: "43" },
  { id: 44, name: "Malatya", plate: "44" },
  { id: 45, name: "Manisa", plate: "45" },
  { id: 46, name: "Kahramanmaraş", plate: "46" },
  { id: 47, name: "Mardin", plate: "47" },
  { id: 48, name: "Muğla", plate: "48" },
  { id: 49, name: "Muş", plate: "49" },
  { id: 50, name: "Nevşehir", plate: "50" },
  { id: 51, name: "Niğde", plate: "51" },
  { id: 52, name: "Ordu", plate: "52" },
  { id: 53, name: "Rize", plate: "53" },
  { id: 54, name: "Sakarya", plate: "54" },
  { id: 55, name: "Samsun", plate: "55" },
  { id: 56, name: "Siirt", plate: "56" },
  { id: 57, name: "Sinop", plate: "57" },
  { id: 58, name: "Sivas", plate: "58" },
  { id: 59, name: "Tekirdağ", plate: "59" },
  { id: 60, name: "Tokat", plate: "60" },
  { id: 61, name: "Trabzon", plate: "61" },
  { id: 62, name: "Tunceli", plate: "62" },
  { id: 63, name: "Şanlıurfa", plate: "63" },
  { id: 64, name: "Uşak", plate: "64" },
  { id: 65, name: "Van", plate: "65" },
  { id: 66, name: "Yozgat", plate: "66" },
  { id: 67, name: "Zonguldak", plate: "67" },
  { id: 68, name: "Aksaray", plate: "68" },
  { id: 69, name: "Bayburt", plate: "69" },
  { id: 70, name: "Karaman", plate: "70" },
  { id: 71, name: "Kırıkkale", plate: "71" },
  { id: 72, name: "Batman", plate: "72" },
  { id: 73, name: "Şırnak", plate: "73" },
  { id: 74, name: "Bartın", plate: "74" },
  { id: 75, name: "Ardahan", plate: "75" },
  { id: 76, name: "Iğdır", plate: "76" },
  { id: 77, name: "Yalova", plate: "77" },
  { id: 78, name: "Karabük", plate: "78" },
  { id: 79, name: "Kilis", plate: "79" },
  { id: 80, name: "Osmaniye", plate: "80" },
  { id: 81, name: "Düzce", plate: "81" }
];

export const TURKEY_DISTRICTS_BY_CITY: Record<string, string[]> = {
  "İstanbul": [
    "Adalar", "Arnavutköy", "Ataşehir", "Avcılar", "Bağcılar", "Bahçelievler", "Bakırköy",
    "Başakşehir", "Bayrampaşa", "Beşiktaş", "Beykoz", "Beylikdüzü", "Beyoğlu", "Büyükçekmece",
    "Çatalca", "Çekmeköy", "Esenler", "Esenyurt", "Eyüpsultan", "Fatih", "Gaziosmanpaşa",
    "Güngören", "Kadıköy", "Kağıthane", "Kartal", "Küçükçekmece", "Maltepe", "Pendik",
    "Sancaktepe", "Sarıyer", "Silivri", "Sultanbeyli", "Sultangazi", "Şile", "Şişli",
    "Tuzla", "Ümraniye", "Üsküdar", "Zeytinburnu"
  ],
  "Ankara": [
    "Akyurt", "Altındağ", "Ayaş", "Bala", "Beypazarı", "Çamlıdere", "Çankaya", "Çubuk",
    "Elmadağ", "Etimesgut", "Evren", "Gölbaşı", "Güdül", "Haymana", "Kahramankazan",
    "Kalecik", "Keçiören", "Kızılcahamam", "Mamak", "Nallıhan", "Polatlı", "Pursaklar",
    "Sincan", "Şereflikoçhisar", "Yenimahalle"
  ],
  "İzmir": [
    "Aliağa", "Balçova", "Bayındır", "Bayraklı", "Bergama", "Beydağ", "Bornova", "Buca",
    "Çeşme", "Çiğli", "Dikili", "Foça", "Gaziemir", "Güzelbahçe", "Karabağlar", "Karaburun",
    "Karşıyaka", "Kemalpaşa", "Kınık", "Kiraz", "Konak", "Menderes", "Menemen", "Narlıdere",
    "Ödemiş", "Seferihisar", "Selçuk", "Tire", "Torbalı", "Urla"
  ],
  "Bursa": [
    "Büyükorhan", "Gemlik", "Gürsu", "Harmancık", "İnegöl", "İznik", "Karacabey", "Keles",
    "Kestel", "Mudanya", "Mustafakemalpaşa", "Nilüfer", "Orhaneli", "Orhangazi", "Osmangazi",
    "Yenişehir", "Yıldırım"
  ],
  "Antalya": [
    "Akseki", "Aksu", "Alanya", "Demre", "Döşemealtı", "Elmalı", "Finike", "Gazipaşa",
    "Gündoğmuş", "İbradı", "Kaş", "Kemer", "Kepez", "Konyaaltı", "Korkuteli", "Kumluca",
    "Manavgat", "Muratpaşa", "Serik"
  ],
  "Kocaeli": [
    "Başiskele", "Çayırova", "Darıca", "Derince", "Dilovası", "Gebze", "Gölcük", "İzmit",
    "Kandıra", "Karamürsel", "Kartepe", "Körfez"
  ],
  "Adana": [
    "Aladağ", "Ceyhan", "Çukurova", "Feke", "İmamoğlu", "Karaisalı", "Karataş", "Kozan",
    "Pozantı", "Saimbeyli", "Sarıçam", "Seyhan", "Tufanbeyli", "Yumurtalık", "Yüreğir"
  ],
  "Konya": [
    "Ahırlı", "Akören", "Akşehir", "Altınekin", "Beyşehir", "Bozkır", "Cihanbeyli", "Çeltik",
    "Çumra", "Derbent", "Derebucak", "Doğanhisar", "Emirgazi", "Ereğli", "Güneysınır", "Hadim",
    "Halkapınar", "Hüyük", "Ilgın", "Kadınhanı", "Karapınar", "Karatay", "Kulu", "Meram",
    "Sarayönü", "Selçuklu", "Seydişehir", "Taşkent", "Tuzlukçu", "Yalıhüyük", "Yunak"
  ],
  "Gaziantep": [
    "Araban", "İslahiye", "Karkamış", "Nizip", "Nurdağı", "Oğuzeli", "Şahinbey", "Şehitkamil", "Yavuzeli"
  ],
  "Mersin": [
    "Akdeniz", "Anamur", "Aydıncık", "Bozyazı", "Çamlıyayla", "Erdemli", "Gülnar", "Mezitli",
    "Mut", "Silifke", "Tarsus", "Toroslar", "Yenişehir"
  ],
  "Kayseri": [
    "Akkışla", "Bünyan", "Develi", "Felahiye", "Hacılar", "İncesu", "Kocasinan", "Melikgazi",
    "Özvatan", "Pınarbaşı", "Sarıoğlan", "Sarız", "Talas", "Tomarza", "Yahyalı", "Yeşilhisar"
  ],
  "Eskişehir": [
    "Alpu", "Beylikova", "Çifteler", "Günyüzü", "Han", "İnönü", "Mahmudiye", "Mihalgazi",
    "Mihalıççık", "Odunpazarı", "Sarıcakaya", "Seyitgazi", "Sivrihisar", "Tepebaşı"
  ],
  "Diyarbakır": [
    "Bağlar", "Bismil", "Çermik", "Çınar", "Çüngüş", "Dicle", "Eğil", "Ergani", "Hani",
    "Hazro", "Kayapınar", "Kocaköy", "Kulp", "Lice", "Silvan", "Sur", "Yenişehir"
  ],
  "Samsun": [
    "19 Mayıs", "Alaçam", "Asarcık", "Atakum", "Ayvacık", "Bafra", "Canik", "Çarşamba",
    "Havza", "İlkadım", "Kavak", "Ladik", "Salıpazarı", "Tekkeköy", "Terme", "Vezirköprü", "Yakakent"
  ],
  "Denizli": [
    "Acıpayam", "Babadağ", "Baklan", "Bekilli", "Beyağaç", "Bozkurt", "Buldan", "Çal",
    "Çameli", "Çardak", "Çivril", "Güney", "Honaz", "Kale", "Merkezefendi", "Pamukkale",
    "Sarayköy", "Serinhisar", "Tavas"
  ],
  "Şanlıurfa": [
    "Akçakale", "Birecik", "Bozova", "Ceylanpınar", "Eyyübiye", "Halfeti", "Haliliye",
    "Harran", "Hilvan", "Karaköprü", "Siverek", "Suruç", "Viranşehir"
  ],
  "Sakarya": [
    "Adapazarı", "Akyazı", "Arifiye", "Erenler", "Ferizli", "Geyve", "Hendek", "Karapürçek",
    "Karasu", "Kaynarca", "Kocaali", "Pamukova", "Sapanca", "Serdivan", "Söğütlü", "Taraklı"
  ],
  "Manisa": [
    "Ahmetli", "Akhisar", "Alaşehir", "Demirci", "Gölmarmara", "Gördes", "Kırkağaç",
    "Köprübaşı", "Kula", "Salihli", "Sarıgöl", "Saruhanlı", "Selendi", "Soma", "Şehzadeler",
    "Turgutlu", "Yunusemre"
  ],
  "Balıkesir": [
    "Altıeylül", "Ayvalık", "Balya", "Bandırma", "Bigadiç", "Burhaniye", "Dursunbey",
    "Edremit", "Erdek", "Gömeç", "Gönen", "Havran", "İvrindi", "Karesi", "Kepsut",
    "Manyas", "Marmara", "Savaştepe", "Sındırgı", "Susurluk"
  ],
  "Kahramanmaraş": [
    "Afşin", "Andırın", "Çağlayancerit", "Dulkadiroğlu", "Ekinözü", "Elbistan",
    "Göksun", "Nurhak", "Onikişubat", "Pazarcık", "Türkoğlu"
  ],
  "Van": [
    "Bahçesaray", "Başkale", "Çaldıran", "Çatak", "Edremit", "Erciş", "Gevaş",
    "Gürpınar", "İpekyolu", "Muradiye", "Özalp", "Saray", "Tuşba"
  ],
  "Aydın": [
    "Bozdoğan", "Buharkent", "Çine", "Didim", "Efeler", "Germencik", "İncirliova",
    "Karacasu", "Karpuzlu", "Koçarlı", "Köşk", "Kuşadası", "Kuyucak", "Nazilli",
    "Söke", "Sultanhisar", "Yenipazar"
  ],
  "Tekirdağ": [
    "Çerkezköy", "Çorlu", "Ergene", "Hayrabolu", "Kapaklı", "Malkara", "Marmaraereğlisi",
    "Muratlı", "Saray", "Süleymanpaşa", "Şarköy"
  ],
  "Hatay": [
    "Altınözü", "Antakya", "Arsuz", "Belen", "Defne", "Dörtyol", "Erzin", "Hassa",
    "İskenderun", "Kırıkhan", "Kumlu", "Payas", "Reyhanlı", "Samandağ", "Yayladağı"
  ],
  "Muğla": [
    "Bodrum", "Dalaman", "Datça", "Fethiye", "Kavaklıdere", "Köyceğiz", "Marmaris",
    "Menteşe", "Milas", "Ortaca", "Seydikemer", "Ula", "Yatağan"
  ],
  "Malatya": [
    "Akçadağ", "Arapgir", "Arguvan", "Battalgazi", "Darende", "Doğanşehir", "Doğanyol",
    "Hekimhan", "Kale", "Kuluncak", "Pütürge", "Yazıhan", "Yeşilyurt"
  ],
  "Trabzon": [
    "Akçaabat", "Araklı", "Arsin", "Beşikdüzü", "Çarşıbaşı", "Çaykara", "Dernekpazarı",
    "Düzköy", "Hayrat", "Köprübaşı", "Maçka", "Of", "Ortahisar", "Sürmene", "Şalpazarı",
    "Tonya", "Vakfıkebir", "Yomra"
  ]
};

export function getDistrictsForCity(cityName: string): string[] {
  if (!cityName) return [];
  // Direct match
  if (TURKEY_DISTRICTS_BY_CITY[cityName]) {
    return TURKEY_DISTRICTS_BY_CITY[cityName];
  }
  // Case/accent-insensitive match
  const normTarget = cityName.trim().toLowerCase();
  for (const [key, districts] of Object.entries(TURKEY_DISTRICTS_BY_CITY)) {
    if (key.toLowerCase() === normTarget) {
      return districts;
    }
  }
  return ["Merkez"];
}
